import Swiper, { Navigation } from 'swiper';

const initCharityImpactSwiper = (scope = document) => {
  const wrappers = scope.querySelectorAll('.charity-impact-swiper-wr');

  wrappers.forEach((el) => {
    const swiperEl = el.querySelector('.swiper');
    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');

    if (!swiperEl || swiperEl.swiper) {
      return;
    }

    const slidesCount = el.querySelectorAll('.swiper-slide').length;

    if (!slidesCount) {
      return;
    }

    new Swiper(swiperEl, {
      modules: [Navigation],
      observer: true,
      observeParents: true,
      slidesPerView: 1.12,
      spaceBetween: 16,
      threshold: 10,
      watchOverflow: true,
      navigation: nextEl && prevEl ? {
        nextEl,
        prevEl,
      } : undefined,
      breakpoints: {
        641: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        901: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
        1023: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
};

initCharityImpactSwiper();
window.initCharityImpactSwiper = initCharityImpactSwiper;
